export const getQueryLastWord = (searchQuery: string): string => getSearchQueryPhrase(searchQuery).pop();

export const getSearchQueryPhrase = (searchQuery) => searchQuery.split(/(AND|OR|NOT)\s+/);
